// @ts-nocheck
import React, { useState, useMemo, useCallback, useEffect } from "react";
import withRouter from "../../Components/Common/withRouter";
import { Card, CardBody, CardTitle, } from "reactstrap";
import EcommerenceOrdersModal from "../Ecommerce/EcommerceOrders/EcommerceOrdersModal";
import TableContainer from "../../Components/Common/TableContainer";
import { useSelector, useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { resetDownloadError } from 'slices/dashboard/reducer';
import {
  getTransactions as onGetTransactions,
  downloadTransactions as onDownloadTransactions
} from 'slices/dashboard/thunk';

const LoadingState = () => (
  <div className="text-center py-4">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
    <p className="mt-2">Loading transactions...</p>
  </div>
);

const ErrorState = ({ onRetry }) => (
  <div className="text-center py-4">
    <div className="text-danger mb-3">
      <i className="bx bx-error-circle display-4"></i>
      <h5 className="mt-2">Error Loading Transactions</h5>
      <p>There was a problem loading your transaction data.</p>
    </div>
    <button 
      className="btn btn-primary" 
      onClick={onRetry}
    >
      <i className="bx bx-refresh me-1"></i> Retry
    </button>
  </div>
);

const EmptyState = () => (
  <div className="text-center py-4">
    <div className="mb-3">
      <i className="bx bx-receipt display-4 text-muted"></i>
      <h5 className="mt-2">No Transactions Available</h5>
      <p className="text-muted">There are currently no transactions to display.</p>
    </div>
  </div>
);

const TransactionsList = ({ columns, transactions }) => (
  <TableContainer
    columns={columns}
    data={transactions || []}
    isGlobalFilter={false}
    tableClass="align-middle table-nowrap mb-0"
    theadClass="table-light"
    isPagination={true}
    paginationWrapper="pagination pagination-rounded justify-content-end mb-2"
    pagination="pagination pagination-rounded"
  />
);

const TransactionsTable: React.FC = () => {

  const dispatch = useDispatch();

  const { 
    transactions: transactionsData,
    downloadTransactions: downloadTransactionsData
  } = useSelector((state: any) => state.partnerDashboard);
  const {user: {user: {partner}}} = useSelector((state: any) => state.Login);

  const {data: transactions, loading: isTransactionsLoading, error: isTransactionsError} = transactionsData;
  const {loading: isDownloading, error: downloadError} = downloadTransactionsData;
  
  const [modal1, setModal1] = useState<boolean>(false);
  const [editDetails, setEditDetails] = useState<any>('');
  const toggleViewModal = useCallback((value: any) => { setModal1(!modal1); setEditDetails(value) }, [modal1]);

  const columnsByPartnerId = useMemo(
    () => [
      {
        id: "transactionDate",
        header: "Transaction Date",
        accessorKey: "createdAt",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (info) => {
          const date = new Date(info.getValue());
          return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).replace(',', '');
        }
      },
      {
        id: "transactionHour",
        header: "Transaction Hour",
        accessorKey: "createdAt",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (info) => {
          const date = new Date(info.getValue());
          return date.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          }).replace(',', '');
        }
      },
      {
        header: "Destination",
        accessorKey: "country",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Category",
        accessorKey: "productCategory",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Product Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "ICCID",
        accessorKey: "esim.iccid",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (info) => {
          const value = info.getValue();
          return value !== null && value !== undefined ? value : "N/A";
        }
      },
      {
        header: "Cost without VAT",
        accessorKey: "price",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Remaining Balance without VAT",
        accessorKey: "partnerDetails.remainingBalance",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (info) => {
          const value = info.getValue();
          return value !== null && value !== undefined ? value : "N/A";
        }
      },
      {
        header: "Product ID",
        accessorKey: "productId",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Transaction ID",
        accessorKey: "transactionId",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Transaction Status",
        accessorKey: "transactionStatus",
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    []
  );

  const columnsByVoucherModel = useMemo(
    () => [
      {
        id: "transactionDate",
        header: "Transaction Date",
        accessorKey: "createdAt",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (info) => {
          const date = new Date(info.getValue());
          return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).replace(',', '');
        }
      },
      {
        id: "transactionHour",
        header: "Transaction Hour",
        accessorKey: "createdAt",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (info) => {
          const date = new Date(info.getValue());
          return date.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          }).replace(',', '');
        }
      },
      {
        header: "Destination",
        accessorKey: "country",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Category",
        accessorKey: "productCategory",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Product Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "ICCID",
        accessorKey: "esim.iccid",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (info) => {
          const value = info.getValue();
          return value !== null && value !== undefined ? value : "N/A";
        }
      },
      {
        header: "Cost",
        accessorKey: "price",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Face Value",
        accessorKey: "faceValue",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Product ID",
        accessorKey: "productId",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Transaction ID",
        accessorKey: "transactionId",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Transaction Status",
        accessorKey: "transactionStatus",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        id: "email",
        header: "Email",
        accessorKey: "email",
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    []
  );

  useEffect(() => {
    // @ts-ignore
    dispatch(onGetTransactions());
  }, [dispatch])

  useEffect(() => {
    if (downloadError) {
      toast.error(
        typeof downloadError === 'string' 
          ? downloadError 
          : 'Failed to download transactions. Please try again later.'
      );
    }
  }, [downloadError]);

  const handleDownloadTransactions = (transactions) => {
    dispatch(onDownloadTransactions({
      startDate: null,
      endDate: null
    }));
  };

  return (
    <React.Fragment>
      <EcommerenceOrdersModal isOpen={modal1} toggle={toggleViewModal} editDetails={editDetails} />
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <CardTitle tag="h4" className="mb-0">Transactions</CardTitle>
            <button 
              className="btn btn-primary" 
              onClick={() => handleDownloadTransactions(transactions)}
              disabled={isTransactionsLoading || isTransactionsError || isDownloading || !transactions || transactions.length === 0}
            >
              {isDownloading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  Downloading...
                </>
              ) : (
                <>
                  <i className="bx bx-download me-1"></i> Download
                </>
              )}
            </button>
          </div>
          
          {isTransactionsLoading && <LoadingState />}
          {isTransactionsError && <ErrorState onRetry={() => dispatch(onGetTransactions())} />}
            
          {!isTransactionsLoading && !isTransactionsError && (
            <>
              {transactions && transactions.length > 0 ? (
                <TransactionsList 
                  columns={partner.voucherModel ? columnsByVoucherModel : columnsByPartnerId} 
                  transactions={transactions} 
                />
              ) : (
                <EmptyState />
              )}
            </>
          )}
        </CardBody>
      </Card>
      <ToastContainer
        onClose={() => dispatch(resetDownloadError())}
      />
    </React.Fragment>
  );
};


export default withRouter(TransactionsTable);
